/*
 * toggleContent compartilhado (dropdown de parcelas + acordeao do FAQ).
 *
 * Antes, esta funcao vivia duplicada dentro dos blocos custom_code de
 * parcelamento e era usada como global por quem estivesse na pagina --
 * inclusive por sections/description-faq.liquid, que nunca a definiu.
 * Desativar um bloco de parcelamento no editor de temas derrubava o dropdown
 * E o FAQ da pagina inteira (product.combo-barberpro-el, templates/product.json).
 *
 * Carregado no fim do <body> em layout/theme.liquid, depois dos blocos, para
 * que esta versao resiliente seja a que vale mesmo onde os blocos ainda
 * declaram a sua propria copia. As copias saem na unificacao dos blocos.
 *
 * Contratos de DOM suportados:
 *   parcelamento -> gatilho #<id>-toggle, seta .a1b2c
 *   FAQ          -> gatilho #<id>-toggleN (fora do padrao), seta .arrow-icon
 */
(function (raiz, fabrica) {
  var api = fabrica();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    // sobrescreve de proposito qualquer definicao anterior vinda dos blocos
    raiz.toggleContent = api.toggleContent;
    raiz.NEToggleContent = api;
  }
})(typeof self !== 'undefined' ? self : this, function () {
  var SELETOR_SETA = '.a1b2c, .arrow-icon';

  function resolverAlvos(id, doc) {
    doc = doc || (typeof document !== 'undefined' ? document : null);
    if (!doc) return null;

    var conteudo = doc.getElementById(id + '-expandableContent');
    if (!conteudo) return null;

    // contrato do parcelamento
    var gatilho = doc.getElementById(id + '-toggle');

    // contrato do FAQ: o id do gatilho nao segue o padrao, entao subimos pelo
    // proprio elemento que carrega o onclick
    if (!gatilho && typeof conteudo.closest === 'function') {
      gatilho = conteudo.closest('[onclick*="toggleContent"]');
    }

    var seta = gatilho ? gatilho.querySelector(SELETOR_SETA) : null;

    return { conteudo: conteudo, gatilho: gatilho, seta: seta || null };
  }

  function agendar(fn, ms) {
    if (typeof setTimeout === 'function') setTimeout(fn, ms);
  }

  function toggleContent(id, doc) {
    var alvos = resolverAlvos(id, doc);
    if (!alvos) return;

    var conteudo = alvos.conteudo;
    var seta = alvos.seta;
    var fechado = conteudo.style.maxHeight === '0px' || !conteudo.style.maxHeight;

    if (fechado) {
      conteudo.style.display = 'block';
      agendar(function () {
        conteudo.style.maxHeight = (conteudo.scrollHeight + 20) + 'px';
        conteudo.style.padding = '15px';
      }, 10);
      if (seta) seta.classList.add('open');
    } else {
      conteudo.style.maxHeight = '0px';
      conteudo.style.padding = '0 15px';
      if (seta) seta.classList.remove('open');
      agendar(function () {
        conteudo.style.display = 'none';
      }, 300);
    }
  }

  return {
    resolverAlvos: resolverAlvos,
    toggleContent: toggleContent
  };
});
